import classNames from 'classnames';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Button, Countdown } from 'hem-ui';
import React from 'react';

type Props = {
  hero: Queries.HomepageHeroFragment;
  titleTag?: 'h1' | 'h2' | 'h3';
  isHomepage?: boolean;
};

const HeroSplitContent: React.FC<Props> = ({
  hero,
  titleTag = 'h1',
  isHomepage,
}) => {
  const Title = titleTag;
  // @ts-expect-error hard typing
  const linkSlug = hero.link?.slug || hero.link?.entry?.slug;

  return (
    <div
      className={classNames(
        'grid grid-rows-2 items-center bg-[color:--hero-text-color] text-center @3xl/hero:grid-cols-2 @3xl/hero:grid-rows-1',
        {
          '@3xl/hero:aspect-[1856/761]': !isHomepage,
          'aspect-[4/5]': isHomepage,
          '@4xl/hero:aspect-[4/3]': isHomepage,
          '@7xl/hero:aspect-[16/9]': isHomepage,
        },
      )}
    >
      <div className="p-[--spacing-page-edges]">
        {!!hero.title && (
          <Title
            className={classNames(
              'mx-auto text-balance text-center !text-[color:--hero-button-color]',
              {
                'hero-headline-h1': titleTag === 'h1',
                'hero-headline-h2': titleTag !== 'h1',
              },
            )}
          >
            {hero.title}
          </Title>
        )}

        {!!hero.description && (
          <p className="mx-auto mt-4 max-w-prose text-balance text-center text-lg text-[color:--hero-button-color]">
            {hero.description}
          </p>
        )}

        {!!hero.countdownTimer && (
          <Countdown countdownTimer={new Date(hero.countdownTimer)} />
        )}

        {!!linkSlug && !!hero.linkLabel && (
          <Button
            to={linkSlug}
            className="mt-8 !bg-[color:--hero-button-color] !text-[color:--hero-button-text-color] @3xl/hero:mt-16 hover:!bg-[color:--hero-button-hover-color] hover:!text-[color:--hero-button-hover-text-color]"
          >
            {hero.linkLabel}
          </Button>
        )}
      </div>
      <GatsbyImage
        className="block aspect-[4/3] h-full w-full object-cover @4xl/hero:hidden"
        alt=""
        image={hero.mobileImage?.gatsbyImageData}
      />
      <GatsbyImage
        className="hidden h-full w-full object-cover @4xl/hero:block"
        alt=""
        image={hero.mobileImage?.gatsbyImageData}
      />
    </div>
  );
};

export default HeroSplitContent;
